import React from 'react';
import Snackbar from 'crehana-ui/Snackbar';
import Text from 'crehana-ui/Text';
import CUILayout from 'crehana-ui/Layout';
import { SnackBarConfirmationTypes } from './types';

const SnackBarConfirmation = ({ ...props }: SnackBarConfirmationTypes) => {
  const { label, icon, open } = props;

  return (
    <CUILayout>
      <Snackbar className="p-16" open={open} position="top-center">
        <div className="flex items-center">
          {icon}
          <Text
            className="ml-12"
            color="base-main"
            responsive="none"
            type="body3"
          >
            {label}
          </Text>
        </div>
      </Snackbar>
    </CUILayout>
  );
};

export default SnackBarConfirmation;
